import { Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * Thermal-receipt "paper": company header + projected body. Not encapsulated so the projected
 * content (which belongs to the parent's view) also picks up `.hr`/`.row`/... — every rule is
 * scoped under `.ticket` to avoid leaking.
 */
@Component({
  selector: 'app-ticket-paper',
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="ticket">
      <div class="ticket-header">
        <div class="company-placeholder-test">EMPRESA DE PRUEBA</div>
        <div class="name">{{ company?.name }}</div>
        <div>
          {{ company?.address }}
          @if(company?.city) { , {{ company.city }} }
        </div>
        @if(company?.cif) {
        <div>CIF {{ company.cif }}</div>
        }
      </div>

      <div class="hr"></div>

      <ng-content></ng-content>
    </div>
  `,
  styles: `
    @media print {
      .ticket {
        width: 100% !important;
        box-shadow: none !important;
        padding: 3mm 3mm 6mm !important;
      }
    }

    .ticket {
      box-sizing: border-box;
      background: #fbfaf7;
      box-shadow: 0 3px 10px rgba(45, 43, 43, 0.16);
      padding: 20px 22px 24px;
      font-family: 'Courier New', ui-monospace, monospace;
      color: #2a2a2a;
      font-size: 12px;
      line-height: 1.5;
    }

    .ticket * {
      box-sizing: border-box;
    }

    .ticket .ticket-header {
      text-align: center;
      margin-bottom: 10px;
    }

    .ticket .ticket-header .name {
      font-weight: 700;
      font-size: 15px;
      letter-spacing: .03em;
    }

    .ticket .hr {
      border-top: 1px dashed #999;
      margin: 8px 0;
    }

    .ticket .row {
      display: flex;
      justify-content: space-between;
      gap: 8px;
    }

    .ticket .row .desc {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ticket .total-row {
      font-weight: 700;
      font-size: 14px;
      margin-top: 4px;
    }

    .ticket .barcode {
      display: flex;
      justify-content: center;
      margin: 8px 0 4px;
    }

    .ticket .barcode-pattern {
      width: 64px;
      height: 64px;
      background: repeating-conic-gradient(#2a2a2a 0 25%, transparent 0 50%) 0 0/8px 8px, #fbfaf7;
    }

    .ticket .barcode-code {
      text-align: center;
      font-size: 10px;
      letter-spacing: .15em;
    }

    .ticket .thanks {
      text-align: center;
      margin-top: 10px;
    }

    /* PLACEHOLDER DE PRUEBA: nombre de empresa temporal hasta tener los datos reales */
    .ticket .company-placeholder-test {
      text-align: center;
      padding: 4px 10px;
      margin-bottom: 6px;
      border: 2px dashed #c00;
      border-radius: 4px;
      font-size: 11px;
      font-weight: 700;
      color: #c00;
      letter-spacing: .5px;
    }
  `,
})
export class TicketPaperComponent {
  @Input() company: any = {};
}
